'use client';

import { Grid, Stack, Text, Title } from '@mantine/core';
import { useRouter } from 'next/navigation';

import { TrackedButton } from '@/components';

const LeftPane = () => {
  const router = useRouter();

  const handleCreateProfileClick = () => {
    router.push('/login');
  };

  return (
    <Grid.Col span={6}>
      {/* Main content */}
      <Stack>
        <Title order={2}>Welcome to Sway</Title>
        <Text
          size="md"
          c="primary.6"
        >
          Connect. Influence. Transform.
        </Text>
      </Stack>
      {/* Button Stack */}
      <Stack style={{ paddingTop: '60px' }}>
        <TrackedButton
          onClick={handleCreateProfileClick}
          variant="primary"
          size="lg"
          trackingName="create_profile"
        >
          CREATE YOUR PROFILE
        </TrackedButton>
      </Stack>
    </Grid.Col>
  );
};

export { LeftPane };
